import {
  ClaveEstrategiaDte,
  EstrategiaDte,
  FilaEstrategiaDte,
  VersionDte,
} from "../../interfaces/utils/estrategias-documentos.interface";
import {
  calcularTributoNoAplica,
  calcularTributoPorCantidadAplicaV1,
  mapearFormProductoConIvaYExentoV1,
  mapearFormProductoConTipoItemV1,
  mapearFormProductoSinCambios,
} from "./estrategias-documentos.v1";

export const VERSION_DTE_V1: VersionDte = 1;

export const VERSION_DTE_POR_DEFECTO: VersionDte = VERSION_DTE_V1;

export const TIPO_DTE_NO_REGISTRADO = "";

export const TIPO_DTE = {
  FACTURA: "01",
  CREDITO_FISCAL: "03",
  NOTA_REMISION: "04",
  NOTA_CREDITO: "05",
  NOTA_DEBITO: "06",
  COMPROBANTE_RETENCION: "07",
  COMPROBANTE_LIQUIDACION: "08",
  DOCUMENTO_LIQUIDACION: "09",
  FACTURA_EXPORTACION: "11",
  SUJETO_EXCLUIDO: "14",
} as const;

export const claveEstrategiaDte = (tipoDte: string, versionDte: VersionDte): ClaveEstrategiaDte =>
  `${tipoDte}|${versionDte}`;

export const ESTRATEGIA_DTE_NO_REGISTRADA: EstrategiaDte = {
  tipoDte: TIPO_DTE_NO_REGISTRADO,
  versionDte: VERSION_DTE_POR_DEFECTO,
  mapearFormCatalogoProducto: mapearFormProductoSinCambios,
  calcularTributo: calcularTributoNoAplica,
};

const FILAS_ESTRATEGIAS_DTE_V1: ReadonlyArray<FilaEstrategiaDte> = [
  { tipoDte: TIPO_DTE.FACTURA,                 mapearFormCatalogoProducto: mapearFormProductoConTipoItemV1,   calcularTributo: calcularTributoPorCantidadAplicaV1 },
  { tipoDte: TIPO_DTE.CREDITO_FISCAL,          mapearFormCatalogoProducto: mapearFormProductoConIvaYExentoV1, calcularTributo: calcularTributoPorCantidadAplicaV1 },
  { tipoDte: TIPO_DTE.NOTA_REMISION,           mapearFormCatalogoProducto: mapearFormProductoConIvaYExentoV1, calcularTributo: calcularTributoPorCantidadAplicaV1 },
  { tipoDte: TIPO_DTE.NOTA_CREDITO,            mapearFormCatalogoProducto: mapearFormProductoConIvaYExentoV1, calcularTributo: calcularTributoPorCantidadAplicaV1 },
  { tipoDte: TIPO_DTE.NOTA_DEBITO,             mapearFormCatalogoProducto: mapearFormProductoConIvaYExentoV1, calcularTributo: calcularTributoPorCantidadAplicaV1 },
  { tipoDte: TIPO_DTE.COMPROBANTE_RETENCION,   mapearFormCatalogoProducto: mapearFormProductoSinCambios,      calcularTributo: calcularTributoNoAplica            },
  { tipoDte: TIPO_DTE.COMPROBANTE_LIQUIDACION, mapearFormCatalogoProducto: mapearFormProductoSinCambios,      calcularTributo: calcularTributoNoAplica            },
  { tipoDte: TIPO_DTE.DOCUMENTO_LIQUIDACION,   mapearFormCatalogoProducto: mapearFormProductoSinCambios,      calcularTributo: calcularTributoNoAplica            },
  { tipoDte: TIPO_DTE.FACTURA_EXPORTACION,     mapearFormCatalogoProducto: mapearFormProductoConIvaYExentoV1, calcularTributo: calcularTributoNoAplica            },
  { tipoDte: TIPO_DTE.SUJETO_EXCLUIDO,         mapearFormCatalogoProducto: mapearFormProductoConTipoItemV1,   calcularTributo: calcularTributoNoAplica            },
];

const registrarFilas = (
  filas: ReadonlyArray<FilaEstrategiaDte>,
  versionDte: VersionDte
): Record<ClaveEstrategiaDte, EstrategiaDte> =>
  filas.reduce((tabla: Record<ClaveEstrategiaDte, EstrategiaDte>, fila: FilaEstrategiaDte) => {
    tabla[claveEstrategiaDte(fila.tipoDte, versionDte)] = { ...fila, versionDte };
    return tabla;
  }, {});

export const TABLA_ESTRATEGIAS_DTE: Readonly<Record<ClaveEstrategiaDte, EstrategiaDte>> = {
  ...registrarFilas(FILAS_ESTRATEGIAS_DTE_V1, VERSION_DTE_V1),
};

export const obtenerEstrategiaDte = (
  tipoDte: string,
  versionDte: VersionDte = VERSION_DTE_POR_DEFECTO
): EstrategiaDte => TABLA_ESTRATEGIAS_DTE[claveEstrategiaDte(tipoDte, versionDte)] ?? ESTRATEGIA_DTE_NO_REGISTRADA;

export * from "./estrategias-documentos.v1";
